module.exports = __webpack_public_path__ + "img/Katarina_home_12.f99a6741.jpg";